import React from "react";
import {
  Col,
  Row,
  Input,
  Label,
  FormFeedback,
  Button,
} from "reactstrap";
import { questionOrderOptions } from "./faqhelpers";


interface faqQuestionFormProps {
  validation: any;
  isEdit?: boolean;
  categories: any[];

}

const FaqQuestionForm: React.FC<faqQuestionFormProps> = ({
  validation,
  isEdit = false,
  categories,

}) => {
  return (
    <form onSubmit={validation.handleSubmit}>
      <div className="px-3 py-2">
        <h5>{isEdit ? "Edit Question" : "New Question"}</h5>
        <Row className="g-3 mt-2">
          <Col md={6}>
            <Label>Select Category <span className="text-danger">*</span></Label>
            <Input
              type="select"
              name="category_id"
              value={validation.values.category_id}
              onChange={validation.handleChange}
              invalid={!!(validation.touched.category_id && validation.errors.category_id)}
            >
             <option value="">Select Category</option>
              {(Array.isArray(categories) ? categories : []).map((item: any) => (
                <option key={item.id} value={item.id}>
                  {item.category_name}
                </option>
              ))}
            </Input>
            <FormFeedback>{validation.errors.category_id}</FormFeedback>
          </Col>
        </Row>
        <Row className="g-3 mt-2">
          <Col md={6}>
            <Label>Select Order <span className="text-danger">*</span></Label>
            <Input
              type="select"
              name="question_order"
              value={validation.values.question_order}
              onChange={validation.handleChange}
              invalid={!!(validation.touched.question_order && validation.errors.question_order)}
            >
              <option value="" disabled hidden>Select Order</option>
                {questionOrderOptions.map((item) => (
                    <option key={item.value} value={item.value}>
                    {item.label}
                    </option>
                ))}
            </Input>
            <FormFeedback>{validation.errors.question_order}</FormFeedback>
          </Col>
          <Col md={6}>
            <Label>Status <span className="text-danger">*</span></Label>
            <Input
              type="select"
              name="status"
              value={validation.values.status}
              onChange={validation.handleChange}
              invalid={!!(validation.touched.status && validation.errors.status)}
              >
              <option value="" disabled hidden>Select Status</option>
              <option value="Active">Active</option>
              <option value="Inactive">Inactive</option>
              
            </Input>
            <FormFeedback>{validation.errors.status}</FormFeedback>
          </Col>
        </Row>
        <Row className="g-3 mt-2">
          <Col md={12} style={{ position: "relative" }}>
            <Label>Question <span className="text-danger">*</span></Label>
            <Input
              type="textarea"
              name="question"
              rows={2}
              value={validation.values.question}
              onChange={(e) => {
                let text = e.target.value;
                let words = text.trim().split(/\s+/);
                if (words.length > 70) {
                  words = words.slice(0, 70);
                  text = words.join(" ");
                }

                validation.setFieldValue("question", text);
              }}
              invalid={!!(validation.touched.question && validation.errors.question)}
              placeholder="Type here..."
            />
            <div
              style={{
                position: "absolute",
                bottom: "6px",
                right: "12px",
                fontSize: "12px",
                color: "#6c757d",
              }}
            >
              {validation.values.question.trim() === ""
                ? 0
                : validation.values.question.trim().split(/\s+/).length}
              /70 words
            </div>
            <FormFeedback>{validation.errors.question}</FormFeedback>
          </Col>

          <Col md={12}>
            <Label>Answer <span className="text-danger">*</span></Label>

            <div className="position-relative">
              <Input
                type="textarea"
                rows={3}
                name="answer"
                value={validation.values.answer}
                onChange={(e) => {
                  let text = e.target.value;
                  let words = text.trim().split(/\s+/);
                  if (words.length > 150) {
                    words = words.slice(0, 150);
                    text = words.join(" ");
                  }

                  validation.setFieldValue("answer", text);
                }}
                invalid={!!(validation.touched.answer && validation.errors.answer)}
                placeholder="Type here..."
              />
              <div
                style={{
                  position: "absolute",
                  bottom: "6px",
                  right: "12px",
                  fontSize: "12px",
                  color: "#6c757d",
                }}
              >
                {validation.values.answer.trim() === ""
                  ? 0
                  : validation.values.answer.trim().split(/\s+/).length}
                /150 words
              </div>
              <FormFeedback>{validation.errors.answer}</FormFeedback>
            </div>
          </Col>
        </Row>
        <div className="d-flex justify-content-end mt-4">
          <Button color="primary" type="submit">
            {isEdit ? "Update " : "Done"}
          </Button>
        </div>
      </div>
    </form>
  );
};

export default FaqQuestionForm;
